module.exports = __webpack_public_path__ + "img/water_meter_fault.d546706a.svg";